/** Merge tags for QMS document ownership transfer emails (dbo.QMSConfig). */

export const QMS_TRANSFER_OWNERSHIP_EMAIL_MERGE_TAGS = [
  { tag: "{{StaffName}}", entityName: "StaffName", description: "New owner display name" },
  {
    tag: "{{TransferredByName}}",
    entityName: "TransferredByName",
    description: "Staff who performed the transfer",
  },
  {
    tag: "{{DocumentCount}}",
    entityName: "DocumentCount",
    description: "Number of documents transferred",
  },
  {
    tag: "{{DocumentListHtml}}",
    entityName: "DocumentListHtml",
    description: "HTML list of transferred documents (auto-generated at send time)",
  },
  {
    tag: "{{TransferReasonBlock}}",
    entityName: "TransferReasonBlock",
    description: "Reason block from auth modal (auto-generated when provided)",
  },
  {
    tag: "{{MyVaultOpenLink}}",
    entityName: "MyVaultOpenLink",
    description: "Open My Vault button — use this only (do not build your own link)",
  },
  {
    tag: "{{OrganizationName}}",
    entityName: "OrganizationName",
    description: "Organisation display name",
  },
];
